<template>
    <ul v-if="currentList.length > 0" class="mt-0 mb-3">
        <h4 v-if="message !== ''" class="gray-60 m-0 third-form-fields-contacts-list-subtitle mb-2">{{ message }} :</h4>
        <li v-for="(contact, index) in list" :key="index" class="jc-space br b-1-gray-05 flex-row mb-2 px-3 gray-0-bkg" :class="{'b-1-primary-10 primary-05-bkg': isSelected, 'p-3': !isSelected}">
            <icon-svg v-if="mode === 'manual'" class="mr-2" icon-name="contact" :width="32" :height="32" viewBox="0 0 32 32">
                <icon-user/>
            </icon-svg> 
       
            <p class="m-0 flex-row jc-space w-5 ellipsis">
                <span class="nowrap self-center flex-column ln-20 fs-3">
                    <span class="bold ellipsis">{{ contact.name }} {{ contact.forename }}</span>
                    <span v-if="mode === 'readOnly'" class="gray-60 ellipsis">{{ contact.email }}</span>
                </span>
                <span class="pl-3 gray-60 self-center wp-10 ellipsis">{{ contact.role }}</span>
                
            </p>
            <div class="flex-row jc-space ml-4">
                <a
                    :data-bot="getDatabot(mode === 'auto' ? 'link-to-opportunity' : 'edit', currentStore, null, 'contact')"
                    v-if="mode !== 'readOnly'"
                    href="javascript:;"
                    @click="$emit('edit-contact', contactIndexExists({index: index, settings: contact}))" 
                    class="fs-3 semibold nowrap aright hover-primary-100 flex-row ai-center">
                    <i v-if="!isSelected" class="icon-plus mr-2"></i>{{ addToListWording }}
                </a>
                <a :data-bot="getDatabot('cancel', currentStore, null, 'contact')" v-if="mode === 'manual'" href="javascript:;" @click="$emit('remove-contact', index)" class="fs-3 semibold nowrap aright hover-primary-100">{{ $l10n.__("Dissocier") }}</a>
                <router-link v-if="mode === 'readOnly' && contact.id" :to="routerLinkParams(contact.id)" target="_blank" class="fs-3 semibold nowrap aright cpointer" >{{ $l10n.__("Voir la fiche") }}</router-link>
            </div>
        </li>
        <a v-if="mode!=='manual' && limitDisplay && !displayEnable" @click="showMore()" class="mt-2 pointer fs-3 semibold">{{ $l10n.__("En afficher plus") }}</a>

    </ul>
</template>

<script>
    import IconUser from 'vcomponents/icons/IconUser.vue';
    import IconSvg from 'vcomponents/icons/IconSvg.vue';
    import DataBotsFormsMixins from "mixins/DataBotsFormsMixins";
    
    export default {
        mixins: [DataBotsFormsMixins],
        props:{
            mode: {
                required: false,
                default: 'manual',
                type: String
            },
            currentList:{
                type: Array,
                required: true
            },
            displayNbSuggestion: {
                type: Boolean,
                required: false,
                default: true
            },
            actionLabel:{
                type: String,
                required: false,
                default: ""
            },
            suggestionMsg:{
                type: String,
                required: false,
                default: ""
            },
            lightForm: {
                type: Boolean,
                required: false,
                default: false
            },
            options:{
                type: Object,
                required: false
            },
            currentStore: {
                type: String,
                required: false,
                default: ''
            }

        },
        components:{ 
            IconSvg,
            IconUser
        },
        data(){
            return{
                limitDisplay: 5
            }
        },
        computed:{
            displayEnable(){
                return this.limitDisplay > this.currentList?.length;
            },
            addToListWording(){
                let label = (!_.isNil(this.actionLabel) ? this.actionLabel : this.$l10n.__("Ajouter"));
                return (this.mode === "manual" ? this.$l10n.__("Modifier") : label)
            },
            list(){
                return this.limitDisplay ? this.currentList.slice(0, this.limitDisplay) : this.currentList
            },
            message(){
                return (this.mode !== "auto" ? this.suggestionsMsgManual : this.suggestionsMsgAuto)
            },
            suggestionsMsgAuto(){
                return this.$l10n.n__("%s CONTACT PROPOSÉ", "%s CONTACTS PROPOSÉS", this.currentList.length, this.currentList.length);
            },
            suggestionsMsgManual(){
                let msg = this.$l10n.n__("%s CONTACT LIÉ À", "%s CONTACTS LIÉS À", this.currentList.length, this.currentList.length);
                return `${msg} ${this.suggestionMsg}`
            },
            isSelected(){
                return this.options?.selected;
            }
        },
        methods:{
            showMore(){
                this.limitDisplay = null;
            },
            /**
             * If index exists, create new contact in suggestion/linked contact list
             */
            contactIndexExists(contact){
                let contactToEdit = {}
                if (this.mode === "manual" && !this.lightForm){
                    contactToEdit = {mode: this.mode ,index: contact.index, contact: null};
                }else{
                    contactToEdit = {mode: this.mode, index: contact.index, settings: contact.settings, customfields: contact.customfields};
                }
                return contactToEdit;
            },
            routerLinkParams(id){
                return {name: "people.overview.informations", params: { id: id }}
            }
        },
        watch:{
            /**
            *   At switch of company, reset value of limitDisplay for suggestion contacts list
             */
            currentList(){
                if(this.mode === "auto" && !this.displayEnable){
                    this.limitDisplay = 5;
                }

            }
        }
    }
</script>
<style scoped lang="scss">
    li {
        padding-top:10px;
        padding-bottom: 10px;
    }
    li:last-child{
        margin-bottom: 0 !important;
    }
    li a:last-child{
        margin-left: 24px !important;
        align-self: center;
    }
    .third-form-fields-contacts-list-subtitle{
        line-height: 20px;
    }
</style>